import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import Typography from "../Typography";

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 600,
  },
}));

const SrLabel = ({ children, error, name }) => {
  const classes = useStyles();

  return (
    <Typography
      className={classes.label}
      component="label"
      variant="body1"
      variantMapping={{ body1: "label" }}
      color={error ? "error" : "textPrimary"}
      htmlFor={name}
    >
      {children}
    </Typography>
  );
};

SrLabel.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.bool,
  name: PropTypes.string,
};

SrLabel.defaultProps = {
  error: undefined,
  name: undefined,
};

export default SrLabel;
